import React from 'react';

import { Row } from '../atoms/row';
import { LinkComponent } from '../atoms/link-component';

import { Inspect as InspectComp } from '../templates/inspect';

const InspectMqtt = () => {
  return (
    <>
      <h1>Inspect Mqtt</h1>

      <Row gap={1}>
        <LinkComponent to="/inspect">Home</LinkComponent>
        <LinkComponent to="/inspect/inverter">Inverter</LinkComponent>
        <LinkComponent to="/inspect/wallbox">Wallbox</LinkComponent>
        <LinkComponent to="/inspect/heat-pump">Heat pump</LinkComponent>
        <LinkComponent to="/inspect/mqtt">MQTT</LinkComponent>
        <LinkComponent to="/inspect/plugs">Plugs</LinkComponent>
        <LinkComponent to="/inspect/spot">Spot</LinkComponent>
        <LinkComponent to="/inspect/plc">PLC</LinkComponent>
      </Row>

      <InspectComp
        variableIds={[
          'MQTT_CLOUD_ENABLED',
          'MQTT_CLOUD_CONNECTED',
          'MQTT_CLOUD_LAST_MESSAGE_AT',
          'DELTA_GREEN_API_ENABLED',
          'DELTA_GREEN_API_CONNECTED',
          'DELTA_GREEN_API_LAST_MESSAGES',
        ]}
      />
    </>
  );
};

export default InspectMqtt;
